import { QuestionPassStateId } from '../../../learnware/LearnwareEnums';
import { QuestionPassState } from '../QuestionPassState';
export class QuestionPassState_Phase3 extends QuestionPassState {
    id = QuestionPassStateId.Phase3;
    name = 'Vokabeln in Phase 3';
    color = 'primary';
    orderInProgressbar = 9;
    constructor(init) {
        super(init);
    }
}
